import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, props: string[]): any[] {
    if (!items) return [];
    if (!searchText || !props || props.length === 0) return items;

    const lowerSearch = searchText.toLowerCase();

    return items.filter((item) =>
      props?.some((prop) =>
        item[prop]?.toString()?.toLowerCase()?.includes(lowerSearch)
      )
    );
  }
}
